import { route, tag, type PageTour } from '../pageTour';

export const systemHealthTour: PageTour = {
  id: 'page-system-health',
  version: 1,
  title: 'System Health',
  summary: 'This site\'s machine: CPU, memory, disks and services.',
  match: route('/node-monitor/:nodeId'),
  steps: [
    {
      target: tag('site-health-status'),
      title: 'Site status',
      description: 'Whether this site is online and reachable from the cloud. All the figures below are read live from the site.',
      side: 'bottom',
    },
    {
      target: tag('site-health-tabs'),
      title: 'Health views',
      description:
        'Switch between live performance, history, camera video pipelines, live streaming, recording and playback, and the site’s uptime log.',
      side: 'bottom',
    },
    {
      target: tag('site-health-machine'),
      title: 'Machine resources',
      description:
        'CPU, memory, disk, temperature and graphics card usage for each machine at the site. Watch for bars running close to full.',
      side: 'bottom',
    },
    {
      target: tag('site-health-services'),
      title: 'Services',
      description:
        'Every service running on the machine and how much it uses. Handy for finding what is slowing a site down.',
      side: 'top',
    },
  ],
};
